import React from 'react';

const recruiters = ['AIIMS Delhi', 'Apollo Hospitals', 'Fortis Healthcare', 'Max Super Specialty', 'Medanta', 'Manipal', 'NHS UK', 'Cleveland Clinic'];
const steps = [
  { step: '1', title: 'Registration', desc: 'Students register with placement cell' },
  { step: '2', title: 'Pre-Placement Training', desc: 'Mock interviews & resume building' },
  { step: '3', title: 'Company Drives', desc: 'On-campus recruitment drives' },
  { step: '4', title: 'Offer & Onboarding', desc: 'Selection & hospital onboarding' },
];

function Placement() {
  return (
    <section id="placement" className="placement-section">
      <div className="section-container">
        <h2 className="section-title"><span className="title-icon">💼</span> Placement & Recruitment</h2>
        <div className="placement-stats">
          <div className="stat-box">
            <span className="stat-icon">🎯</span>
            <span className="stat-val">98%</span>
            <span className="stat-lbl">Placement Rate</span>
          </div>
          <div className="stat-box">
            <span className="stat-icon">💰</span>
            <span className="stat-val">₹6.5 LPA</span>
            <span className="stat-lbl">Avg Package</span>
          </div>
          <div className="stat-box">
            <span className="stat-icon">🏢</span>
            <span className="stat-val">50+</span>
            <span className="stat-lbl">Top Recruiters</span>
          </div>
          <div className="stat-box">
            <span className="stat-icon">🌍</span>
            <span className="stat-val">15+</span>
            <span className="stat-lbl">Countries</span>
          </div>
        </div>
        <div className="placement-content">
          <div className="recruiters-section">
            <h3>Our Top Recruiters</h3>
            <div className="recruiters-grid">
              {recruiters.map((rec, i) => (
                <div key={i} className="recruiter-card">{rec}</div>
              ))}
            </div>
          </div>
          <div className="process-section">
            <h3>Placement Process</h3>
            <div className="steps-timeline">
              {steps.map((s, i) => (
                <div key={i} className="step-item">
                  <div className="step-number">{s.step}</div>
                  <div className="step-info">
                    <h4>{s.title}</h4>
                    <p>{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="placement-cta">
              <button className="btn btn-primary">For Students: Register</button>
              <button className="btn btn-secondary">For Recruiters: Partner With Us</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Placement;